





















# import settings from '@/settings'
import Menus from '@/components/menus'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import vpe_table from '@/components/vpe/vpe_table'
import params_string from '@/components/vpe/params_string'

export default {
    name: 'users_variable_payroll'

    components: { Menus, vpe_table, params_string }

    props:
        date_prop:
            required: false

    watch:
        date_prop: (new_value, old_value)->
            # console.log "WATCH DATE PROP", new_value, old_value
            if new_value != old_value
                if new_value in ['', null, undefined]
                    @date = t.python_date_formatter(new Date()).split(' ')[0]
                else
                    @date = new_value

    data: ()->
        date: ''
        vp_custom_set: []
        # params_dates: []
        # not_this_month: false

    methods:
        # new_dates: (dates)->
        #     @params_dates = dates
        #     today = new Date(Date.now()).setHours(0,0,0)
        #     if today <= dates[1].getTime()
        #         @not_this_month = false
        #     else
        #         @not_this_month = true
        #     return

        get_vpc_set: ()->
            self = @
            q.run('get_vpc_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_variable_payroll: get_vpc_set: then", e.message)
                else
                    # console.log "GET_VPC_SET : ", resp.body.data.variable_payroll_custom_set
                    if resp.body.data.variable_payroll_custom_set != null
                        self.vp_custom_set = resp.body.data.variable_payroll_custom_set
            .catch (resp)->
                n.catch_error(resp, "company_variable_payroll: get_vp_custom_dated_set()")
            
    beforeMount: ()->
        # console.log "beforeMount users_variable_payroll", @date_prop, @date
        if @date_prop not in [undefined, null, '']
            @date = @date_prop
        if @date_prop in [undefined, null, ''] and @date == ''
            @date = t.python_date_formatter(new Date()).split(' ')[0]
        @get_vpc_set()
}
